import McDataServices from './McDataServices'
import { isReferrerAllowed } from '../pages/mc-components/McPageHelpers'

import CONSTANTS from '../utils/Constants'

export const getUserDetailsAndProcess = (isLoggedIn, user, setUser, getUserEvenIfNotEmpty = false) => {
  if (
    isLoggedIn &&
        (Object.keys(user)?.length === 0 || getUserEvenIfNotEmpty) &&
        user.constructor === Object
  ) {
    const storageUserName = localStorage.getItem('username')
    const username = isReferrerAllowed() ? storageUserName || 'anonymous' : storageUserName
    if (username !== '') {
      McDataServices.getUser(username).then(async (userData) => {
        const searchCountrySet = userData.rules.find(item => item.type === 'SEARCH_COUNTRY_SET')

        if (searchCountrySet !== undefined) {
          const searchCountrySetParameters = searchCountrySet.parameters

          if (!searchCountrySetParameters.allowedSearchCountries?.trim()) {
            searchCountrySetParameters.allowedSearchCountries = CONSTANTS.WORLD_COUNTRY_CODE
          }
          searchCountrySetParameters.allowedSearchCountries = searchCountrySetParameters.allowedSearchCountries.replace(/\s+/g, '').split(',')
        }

        const b2bAccountIds = userData.followedB2bAccountIds
          ? Object.keys(userData.followedB2bAccountIds)
          : []

        if (b2bAccountIds.length > 0) {
          try {
            const b2bUsers = await McDataServices.getUsersByB2bAccount(b2bAccountIds)
            b2bUsers.forEach(b2bUser => {
              const accountId = b2bUser.ownedB2bAccountId
              if (accountId && userData.followedB2bAccountIds[accountId]) {
                userData.followedB2bAccountIds[accountId] = {
                  ...userData.followedB2bAccountIds[accountId],
                  ...b2bUser
                }
              }
            })
          } catch (err) {
            console.error('Failed to fetch B2B user data:', err)
          }
        }

        setUser(userData)
      })
    }
  } else if (!isLoggedIn) {
    localStorage.setItem('username', '')
  }
}
